import { createContext } from "react";

export type ModalId = (typeof MODAL_ORDER)[number];

export const initialModalManagerContext = {
    isInModalManagerContext: false,
    modalToDisplay: null as ModalId | null,
    askToDisplayModal: (_modalId: ModalId) => {},
    removeModalFromDisplay: (_modalId: ModalId) => {},
};

export const ModalManagerContext = createContext(initialModalManagerContext);

export const MODAL_ORDER = [
    // Highest priority
    "cookie-settings-modal",
    "navigation-confirmation-modal",
    "billing-modal",
    "complete-profile-confirmation-modal",
    "calendar-change-confirmation-modal",
    "booking-start-times-confirmation-modal",
    "client-preferred-name-modal",
    "client-description-modal",
    "trial-extension",
    "are-you-sure-you-want-to-reschedule-modal",
    "scheduler",
    "try-coach-scheduler",
    "coach-terms-modal",
    "youve-been-paired-with",
    "session-confirmation-modal",
    "update-phone-number-modal",
    "phone-verification-modal",
    "email-verification-modal",
    "onboarding-modal",
    "email-verification-reminder-modal",
    "too-many-tabs-modal",
    "pay-us-modal",
    "recording-permissions-modal",
    "recording-declined-modal",
    "swap-coaches-modal",
    "confirm-free-week-after-switch-coach-modal",
    "switch-coach-modal",
    "confirm-post-payment-coach-pick-modal",
    "coach-search-support-request-modal",
    "google-login-failed-modal",
    "must-use-chrome-modal",
    "new-client-modal",
    "report-no-show-modal",
    "no-show-cap-reached-modal",
    "confirmation-modal",
    "minimal-edit-reminder-modal",
    "plan-updated-modal",
    "what-is-a-sprint-modal",
    "how-coaching-works-modal",
    "edit-potential-client-message-template-modal",
    "auto-send-prompt-modal",
    "batch-potential-clients-notification-modal",
    "delete-user-modal",
    "exercise-picker-modal",
    "live-exercise-start-modal",
    "confirm-end-call-modal",
    "delete-note-modal",
    "cancel-recurring-slot-modal",
    "stop-accepting-clients-modal",
    "start-accepting-clients-modal",
    "timezone-change-warning-modal",
    "cancel-appointment-modal",
    "appointment-review-modal",
    "coach-review-modal",
    "quit-flow-coach-review-confirmation",
    "confirm-resume-subscription-modal",
    "resume-coaching-change-plan-modal",
    "resume-coaching-payment-method-modal",
    "welcome-back-modal",
    "payment-failed-modal",
    "pending-followup-tasks-modal",
    "update-payment-method-modal",
    "video-quality-rating-modal",
    "confirm-live-share-goals-board",
    "empty-board-action-items-modal",
    "offer-accepted-modal",
    "maintenance-plan-accepted-modal",
    "pause-plan-started-modal",
    "change-matching-preferences-modal",
    "disable-coach-assistant-modal",
    "position-form-modal",
    "commit-and-save-offer-modal",
    "session-debrief-modal",
    "gift-free-trial-modal",
    "delete-reminder-confirmation",
    "delete-milestone-recap-confirmation",
    "resume-coaching-confirmation-modal",
    "plan-ended-confirmation-modal",
    "move-to-inactive-confirmation-modal",
    "terms-and-policy-update-confirmation-modal",
    "enable-face-id-modal",
    "cap-additional-terms",
    "mobile-app-screen",
    "coach-mobile-app-screen",
    "share-session-recording-modal",
    "add-to-calendar-modal",
    "confirm-dial-out-modal",
    "linkedin-delete-position-modal",
    "delete-upcoming-topic-modal",
    "overwritten-drafts-modal",
    "remind-coach-to-call-client-modal",
    // Lowest priority
] as const;

export const MODAL_PRIORITY = MODAL_ORDER.reduce(
    (acc, modal, index) => {
        acc[modal as ModalId] = MODAL_ORDER.length - index;
        return acc;
    },
    {} as Record<ModalId, number>,
);

export const modalsToDisplay = new Set<ModalId>();
